import { MainLayout } from 'components/Layout';
import { useEffect } from 'react';

export const FinancialServicesDisclaimer = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // change to 'auto' if you want instant
      });
    }, []);
  return (
    <MainLayout
      title="Financial Services Disclaimer | Fundo"
      description="Important information regarding financial services accessed through Fundo."
    >
      {/* HEADER */}
      <section className="max-w-3xl">
        <p className="text-xs uppercase tracking-[0.35em] text-[#8b5e3c]">Financial Disclaimer</p>

        <h1 className="mt-4 font-serif text-5xl leading-[0.95] tracking-[-0.04em] text-[#1b140f] sm:text-6xl">
          How financial services work on Fundo.
        </h1>

        <p className="mt-6 text-lg leading-8 text-[#4f4034]">
          This disclaimer explains the nature of financial services accessed through the Fundo
          platform.
        </p>

        <p className="mt-4 text-sm text-[#8b5e3c]">Last updated: April 2026</p>
      </section>

      {/* CONTENT */}
      <section className="mt-20 max-w-3xl space-y-14">
        {/* NOT A FINANCIAL INSTITUTION */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">
            1. Fundo is Not a Financial Institution
          </h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo is a technology platform and does not operate as a bank, lender, insurer, or
            financial advisor. Any financial services made available through Fundo are provided by
            third-party partners.
          </p>
        </div>

        {/* THIRD PARTY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">2. Third-Party Providers</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Loans, savings products, insurance, and payment services may be offered by independent
            financial institutions. These providers are solely responsible for their products,
            terms, approvals, and obligations.
          </p>
        </div>

        {/* NO GUARANTEES */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">3. No Guarantees or Advice</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo does not guarantee approval for any financial product, nor does it provide
            financial, investment, or legal advice. Users are responsible for evaluating any
            financial decisions they make.
          </p>
        </div>

        {/* ELIGIBILITY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">4. Eligibility & Approval</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Access to financial services may be subject to eligibility criteria, credit assessments,
            and regulatory requirements defined by third-party providers.
          </p>
        </div>

        {/* RISKS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">5. Financial Risks</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Financial products carry risks, including repayment obligations, interest charges, and
            potential loss. Users should carefully review all terms provided by financial partners
            before proceeding.
          </p>
        </div>

        {/* PAYMENTS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">6. Payments & Transactions</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Payment processing may be facilitated through third-party providers. Fundo is not
            responsible for delays, failures, or errors in payment processing.
          </p>
        </div>

        {/* DATA SHARING */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">7. Data Sharing with Partners</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            By using financial services through Fundo, you consent to the sharing of relevant
            information with third-party providers where necessary to facilitate those services.
          </p>
        </div>

        {/* LIMITATION */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">8. Limitation of Responsibility</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo is not liable for any financial losses, obligations, or disputes arising from
            services provided by third-party financial institutions.
          </p>
        </div>

        {/* UPDATES */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">9. Changes to This Disclaimer</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            This disclaimer may be updated periodically. Continued use of Fundo indicates acceptance
            of any updates.
          </p>
        </div>

        {/* CONTACT */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">10. Contact</h2>
          <p className="mt-4 text-[#4f4034] leading-8">
            For questions regarding financial services on Fundo, contact:
          </p>

          <p className="mt-4 text-sm text-[#8b5e3c]">fundofarmer@gmail.com</p>
        </div>
      </section>
    </MainLayout>
  );
};
